import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "commissions",
    name: "Commission",
    version: "0.2.0",
    tier: "addon",
    accent: "promotions",
    dependsOn: ["sites", "operators"],
    appliesTo: { operatingModel: ["commission"] },
    description: "Commission for operator-run sites: dated rates by fuel grade and category, monthly statements that become self-billing invoices on cash office sign-off, accepted or queried by the operator.",
    permissions: {
        view: "See commission rates and statements for your sites",
        rates: "Set commission rates and items (head office)",
        statements: "Cash office: work out, adjust and sign off statements into invoices; answer operator queries",
    },
    grants: {
        "Head office": ["view", "rates", "statements"],
        "Area manager": ["view"],
        "Site manager": ["view"],
    },
    tasks: [
        { key: "invoice-to-accept", when: { operatingModel: ["commission"] }, title: "Commission invoice to accept", description: "A commission invoice has been issued to the site. Clears when the site accepts it (or queries it).", level: "action", audience: "sites", clear: "fix", icon: "percent", sort: 10, notify: false },
        { key: "invoice-held", when: { operatingModel: ["commission"] }, title: "Commission invoice held", description: "A commission invoice couldn't be issued because its site had no managing company on the invoice's date. Clears when the site is given one in Sites (the invoice is then issued).", level: "action", audience: "routed", clear: "fix", link: "/sites?panel=entities", icon: "percent", sort: 15, notify: false },
        { key: "invoice-queried", when: { operatingModel: ["commission"] }, title: "Commission invoice queried", description: "A site has queried its commission invoice. Clears when it's answered and accepted.", level: "urgent", audience: "routed", clear: "fix", link: "/commissions", icon: "percent", sort: 20, notify: false },
    ],
    widgets: [
        { key: "invoices", when: { operatingModel: ["commission"] }, title: "Commission invoices", description: "Invoices waiting for the operator to accept, and any they've queried, by site.", group: "Cash office", size: 1, permission: "view", defaultOn: true, order: 57 },
    ],
    nav: [
        { label: "Commission", path: "/commissions", section: "cash", tab: "Commission", tabIcon: "percent", permission: "view", icon: "percent", order: 65, when: { operatingModel: ["commission"] }, blurb: "Commission rates and monthly statements for commission sites" },
    ],
    setup: [
        {
            id: "rates",
            title: "Commission rates",
            scope: "site",
            when: { operatingModel: ["commission"] },
            bulk: { label: "Commission rates for every site", path: "/commissions/rates", blurb: "Set one site's rates, then copy them to the rest in one go." },
            why: "Statements are worked out from each commission site's rates, so every commission site needs them set.",
            blocking: false,
            fields: [],
        },
    ],
});
